module.exports = __webpack_public_path__ + "static/media/FORSDS900120 MACHINES.47469cd0.jpg";